<template>
  <div>
    <div class="item" @click="itemClick">
      <i
        class="fas"
        :class="item.isExpanded ? 'fa-angle-right' : 'fa-angle-down'"
        v-if="isDropdown"
      ></i>
      <h1
        class="itemTitle"
        :class="isDropdown ? 'dropdownTitle' : 'notDropdownTitle'"
      >
        {{ item.name }}
      </h1>
      <div class="arrow">
        <i class="fas fa-angle-right" v-if="!isDropdown"></i>
      </div>
    </div>

    <div class="itemInfo" v-if="item.isExpanded">
      <InfoCard :card="card" v-for="(card, index) in item.cards" :key="index" />
    </div>
  </div>
</template>

<script src="./ShowcaseItem.js"></script>

<style src="./ShowcaseItem.scss" lang="scss" scoped></style>
